import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const lanesApiRoutes = {
    list: apiDataManagerBaseURL + "lanes/",
    create: apiDataManagerBaseURL + "lanes/",
    update: apiDataManagerBaseURL + "lanes/",
    delete: apiDataManagerBaseURL + "lanes/",
};

export class LaneAPI {
    static list(type, laneType, countyEdition) {
        const url = `${lanesApiRoutes.list}${type}/${laneType}/${countyEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
    
    static listByProvider(type, provider = '') {
        const url = `${lanesApiRoutes.list}${type}/providerLanes/getAll`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
            });
    }

    static create(type, laneType, countyEdition, lane) {
        const createUrl = `${lanesApiRoutes.create}${type}/${laneType}/${countyEdition}`

        return API.authenticatedRequest({
            url: createUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(lane)
        });
    }

    static createByProvider(type, lane) {
        const createUrl = `${lanesApiRoutes.create}${type}/providerLanes/create`

        return API.authenticatedRequest({
            url: createUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(lane)
        });
    }

    static update(type, laneType, countyEdition, id, lane) {
        const updateUrl = `${lanesApiRoutes.update}${type}/${laneType}/${countyEdition}/${id}`

        return API.authenticatedRequest({
            url: updateUrl,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(lane)
        });
    }

    static updateByProvider(type, id, lane) {
        const updateUrl = `${lanesApiRoutes.update}${type}/providerLanes/update/${id}`

        return API.authenticatedRequest({
            url: updateUrl,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(lane)
        });
    }

    static delete(type, laneType, countyEdition, id) {
        const deleteUrl = `${lanesApiRoutes.delete}${type}/${laneType}/${countyEdition}/${id}`

        return API.authenticatedRequest({
            url: deleteUrl,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteByProvider(type, id) {
        const deleteUrl = `${lanesApiRoutes.delete}${type}/providerLanes/delete/${id}`

        return API.authenticatedRequest({
            url: deleteUrl,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
